import React, { useEffect, useState } from 'react';
import { getCaller } from '../../services/api';
import TableData from '../TableData';
import './dashboard.css';
import MeetingForm from './MeetingForm';

const Dashboard = () => {
  const [meetings, setMeetings] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState('day'); 
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const fetchMeetings = async (filter, start, end) => {
    try {
      let queryParam = '';
      if (filter) queryParam += `?filter=${filter}`;
      if (filter === 'custom' && start && end) {
        queryParam += `&start_date=${start}&end_date=${end}`;
      }
      const response = await getCaller(`meeting${queryParam}`);
      setMeetings(response?.data || []);
    } catch (error) {
      console.error('Error fetching meetings:', error);
    }
  };

  useEffect(() => {
    fetchMeetings(selectedFilter, startDate, endDate);
  }, [selectedFilter, startDate, endDate]);

  return (
    <>
      <div className="dashboard-container">
        <div className="header">
          <h3>Meeting Scheduler</h3>
        </div>

        <div className="search-container">
          <div className="input-group">
            <select
              className="filter-dropdown"
              value={selectedFilter}
              onChange={(e) => setSelectedFilter(e.target.value)}
            >
              <option value="day">Today</option>
              <option value="month">Month</option>
              <option value="year">Year</option>
              <option value="custom">Custom</option>
            </select>
          </div>

          {selectedFilter === 'custom' && (
            <div className="date-picker-group">
              <input
                type="date"
                className="date-input"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
              <input
                type="date"
                className="date-input"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          )}
          <div className="button-group">
            <button type="button" className="search-button" onClick={() => setIsModalOpen(true)}>
              Schedule Meeting
            </button>
          </div>
        </div>
      </div>
      <TableData meetings={meetings} fetchMeetings={() => fetchMeetings(selectedFilter, startDate, endDate)}/>
      {isModalOpen && <MeetingForm closeModal={() => setIsModalOpen(false)} fetchMeetings={() => fetchMeetings(selectedFilter, startDate, endDate)} />}
        
    </>
  );
};

export default Dashboard;
